// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const toolTips = {
  tool_tips: {
    contentful_name: 'Tool Tips (DEFAULT DO NOT CHANGE)',
    picwell_score: {
      text: 'Your plan score rates the value that each plan provides after accounting for premiums, plan details, your preferences, and the predicted health care cost and risk of "people like you".',
      title: 'Plan Score',
      underline: 'Plan Score',
    },
    pay_period: {
      title: '工资周期',
      weekly: {
        text: '每周:每周在特定的星期几(例如,每周五)。每年52次工资发放。',
        underline: '/周',
      },
      yearly: {
        text: '每年:一年内的总金额。',
        underline: '/年',
      },
      monthly: {
        text: '每月:每月在特定日期(例如,26日)。每年{x}次工资发放。',
        underline: '/月',
      },
      biWeekly: {
        text: '双周:每两周在特定的星期几(例如,每隔一个周五)。每年26次工资发放。',
        underline: '/双周',
      },
      perPaycheck: {
        text: '每次发薪:每次发放工资时。每年{x}次工资发放。',
        underline: '/次',
      },
      semiMonthly: {
        text: '半月:每月两次在两个特定日期(例如,15日和月末最后一天)。每年24次工资发放。',
        underline: '/半月',
      },
    },
    number_with_pay_period: {
      yearly: {
        text: '一年的总金额。',
        title: '年度',
        underline: '/年',
      },
      pay_period: {
        title: '工资周期',
        weekly: {
          text: '每周:每周在特定的星期几发放(例如,每周五)。每年52次工资发放。',
          underline: '/周',
        },
        yearly: {
          text: '年度:一年的总金额。',
          underline: '/年',
        },
        monthly: {
          text: '每月:每月在特定日期发放(例如,每月26日)。每年{x}次工资发放。',
          underline: '/月',
        },
        biWeekly: {
          text: '双周:每两周在特定的星期几发放(例如,每隔一个周五)。每年26次工资发放。',
          underline: '/双周',
        },
        semiMonthly: {
          text: '半月:每月两次在两个特定日期发放(例如,每月15日和月末最后一天)。每年24次工资发放。',
          underline: '/半月',
        },
      },
    },
    hsa: {
      text: 'HSA是一种特殊账户,让您可以储蓄和投资资金来支付医疗保健费用。',
      title: '健康储蓄账户',
      underline: '健康储蓄账户(HSA)',
    },
    recommended_hsa_contribution: {
      text: '您需要储蓄多少来支付您的预估费用。如果您选择此计划,可以在下一步设置缴款金额。',
      title: '目标HSA缴款额',
      underline: '目标HSA缴款额',
    },
    hra: {
      text: 'HRA是由您的雇主设立的账户,用于帮助支付保险不承保的医疗费用。',
      title: '健康报销账户',
      underline: '健康报销账户(HRA)',
    },
    estimated_yearly_total: {
      text: {
        p1: '您的年度保费(保费 x 每个支付周期)',
        p2: '加上您的自付费用估算。',
      },
      title: '预计年度总额',
      underline: '预计年度总额',
    },
    premium: {
      text: '您为参加健康保险计划而支付的金额。',
      title: '保费',
      underline: '保费',
    },
    annual_premium: {
      text: '您全年为参加健康保险计划所支付的金额。',
      title: '年度保费',
      underline: '年度保费',
    },
    out_of_pocket_estimate: {
      text: 'ALEX 估算您一年内在医疗保健服务上的花费金额。',
      title: '自付费用估算',
      underline: '自付费用',
    },
    striked_oop_estimate: {
      text: '这个划掉的数字是扣除您雇主{x}贡献之前的价格。',
      underline: '(为什么?)',
    },
    deductible: {
      text: '在保险开始承担部分费用之前,您需要自行支付的金额。达到免赔额后,您将为后续接受的医疗服务支付共付额或共同保险。',
      title: '免赔额',
      underline: '免赔额',
    },
    out_of_pocket_max: {
      text: '您在一年内为承保医疗保健支付的最高金额。一旦达到自付费用上限,保险将支付任何额外承保费用的100%。',
      title: '自付费用上限',
      underline: '自付最高限额',
    },
    primary_care_copay: {
      text: '当您前往您的初级保健医生处治疗疾病或伤害时需要支付的金额。常规预防性护理通常在网络内全额承保。',
      title: '初级保健自付额',
      underline: '初级保健自付额',
    },
    primary_care_coinsurance: {
      text: '当您前往您的初级保健医生处治疗疾病或损伤时,您需要支付的总费用百分比。常规预防性护理通常在网络内全额承保。',
      title: '初级保健共同保险',
      underline: '初级保健共同保险',
    },
    specialist_care_copay: {
      text: '当您去看专科医生(例如过敏科医生、皮肤科医生)时需要支付的金额。',
      title: '专科医疗共付额',
      underline: '专科医疗共付额',
    },
    specialist_care_coinsurance: {
      text: '当您去看专科医生(例如过敏科医生、皮肤科医生)时,您需要支付的总费用百分比。',
      title: '专科医疗共同保险',
      underline: '专科医疗共同保险',
    },
    generic_drug_copay: {
      text: '您为仿制药或第一级处方药支付的金额。共付额通常适用于一个月的药量。',
      title: '仿制药共付额',
      underline: '仿制药共付额',
    },
    generic_drug_coinsurance: {
      text: '您为通用药或第一级处方药支付的总费用百分比。',
      title: '通用药共同保险',
      underline: '通用药共同保险',
    },
    brand_drug_copay: {
      text: '您为品牌药或第二级处方药支付的金额。共付额通常适用于一个月的药量。',
      title: '品牌药共付额',
      underline: '品牌药共付额',
    },
    brand_drug_coinsurance: {
      text: '您为品牌药或第二级处方药支付的总费用百分比。',
      title: '品牌药共同保险',
      underline: '品牌药共同保险',
    },
    non_formulary_drug_copay: {
      text: '您为不在计划处方集内的处方药支付的金额。共付额通常适用于一个月的用量。',
      title: '非处方集药物共付额',
      underline: '非处方集药物共付额',
    },
    non_formulary_drug_coinsurance: {
      text: '您为计划处方集中未包含的处方药支付的总费用百分比。',
      title: '非处方集药物共同保险',
      underline: '非处方集药物共同保险',
    },
    specialty_drug_copay: {
      text: '您为专科处方药支付的总费用百分比。',
      title: '专科药品共付额',
      underline: '专科药品共付额',
    },
    specialty_drug_coinsurance: {
      text: '您为专科药物或第三级处方药支付的总费用百分比。',
      title: '专科药物共同保险',
      underline: '专科药物共同保险',
    },
    tier1_deductible: {
      text: '适用于您从一级医疗服务提供者处获得的医疗保健服务的免赔额。',
      title: '一级免赔额',
      underline: '一级免赔额',
    },
    tier2_deductible: {
      text: '适用于您从网络内非一级指定医疗服务提供者处接受医疗保健服务的免赔额。',
      title: '二级免赔额',
      underline: '二级免赔额',
    },
    in_network_deductible: {
      text: '适用于您从网络内医疗服务提供者处接受医疗保健服务的免赔额。',
      title: '网络内免赔额',
      underline: '网络内免赔额',
    },
    out_of_network_deductible: {
      text: '适用于您从网络外医疗服务提供者处接受医疗保健服务的免赔额。',
      title: '网络外免赔额',
      underline: '网络外免赔额',
    },
    combined_network_deductible: {
      text: '适用于您从医疗服务提供者处接受医疗保健服务的免赔额。',
      title: '免赔额',
      underline: '免赔额',
    },
    in_network_out_of_pocket_limit: {
      text: '您在一年内为从网络内医疗服务提供者处获得的承保医疗保健服务支付的最高金额。一旦达到此限额,您的保险将支付任何额外承保的网络内费用的100%。',
      title: '网络内自付费用限额',
      underline: '网络内自付费用限额',
    },
    out_of_network_out_of_pocket_limit: {
      text: '您在一年内为从网络外医疗服务提供者处获得的承保医疗保健服务支付的最高金额。一旦达到此限额,您的保险将支付任何额外承保的网络外费用的100%。',
      title: '网络外自付费用限额',
      underline: '网络外自付费用限额',
    },
    combined_network_out_of_pocket_limit: {
      text: '您在一年内为从医疗服务提供者处获得的承保医疗保健服务支付的最高金额。一旦达到此限额,您的保险将支付任何额外承保费用的100%。',
      title: '自付费用上限',
      underline: '自付费用上限',
    },
    yearly_estimate_greater_than_out_of_pocket_limit: {
      text: '您的预估自付费用(OOP)高于本计划的自付费用上限。当像您这样的人可能使用本计划不承保的医疗保健服务或处方药时,费用估算可能会超过自付费用上限。只要您仅获得本计划网络内且承保的医疗护理或处方药,您的费用就不会超过自付费用上限。',
      title: '注意:',
    },
    family_threshold: {
      text: '您的福利摘要可能包括"个人"和"家庭"阈值。请在下方输入"家庭"阈值的数值。',
      title: '家庭阈值',
    },
    remaining_oop: {
      text: '这是ALEX预测您将在医疗保健费用上花费的平均金额,减去雇主提供的任何HSA或HRA供款。',
      title: '剩余自付费用',
    },
    account_eligibility: {
      text: '某些计划可能符合特殊账户的资格,这些账户可以帮助您支付医疗保健费用。',
      title: '账户资格',
    },
    plan_type: {
      text: '您可能有几种不同类型的计划可供选择。计划类型因多种因素而异,包括该计划是否涵盖网络外医疗服务提供者、您是否需要转诊才能看专科医生,以及您如何支付医疗费用。',
      title: '计划类型',
    },
  },
};
